export function isEmpty(obj: any) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
export function flattenObjForDynamic<
  T extends { [key: string]: unknown } = { [key: string]: unknown },
>(obj: T, omit?: string[]): { [key: string]: unknown } {
  const result: { [key: string]: unknown } = {};

  for (const i in obj) {
    if (omit && omit.includes(i)) continue;
    const value = obj[i];
    if (typeof value === 'object' && !Array.isArray(value)) {
      const temp = flattenObjForDynamic(
        value as { [key: string]: unknown },
        omit,
      );
      for (const j in temp) {
        // Store temp in result
        result[j] = temp[j];
      }
    } else if (Array.isArray(value)) {
      result[i] = value
        .map((val: { [key: string]: unknown }, index) => {
          if (typeof val === 'object') {
            return flattenObjForDynamic(val, omit);
          }
          return val;
        })
        .filter(
          (val, index) =>
            !(index !== 0 && typeof val === 'object' && isEmpty(val)),
        );
    } else {
      result[i] = value;
    }
  }
  return result;
}
export const deepCopy = <T>(source: T): T => {
  return JSON.parse(JSON.stringify(source)) as T;
};
